import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import OutlinedSelectInputChipped from '../../../Global/Inputs/OutlinedSelectChipped';
import _get from 'lodash/get';
export default class ReferenceMultiSelect extends PureComponent {
  static propTypes = {
    fieldNumber: PropTypes.number.isRequired,
    fieldOptions: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    values: PropTypes.array.isRequired,
    validateField: PropTypes.func.isRequired
  };
  state = { selectOptions: [] };
  componentDidMount() {
    const {
      fieldOptions: { listItems }
    } = this.props;
    const selectOptions = listItems.map(item => {
      return { value: item, title: item };
    });
    this.setState({ selectOptions });
  }
  _handleChange = (form, { target: { name, value } }) => {
    const { errors } = form;
    const error = _get(errors, name, '');
    if (error && value.length > 0) {
      // so i revalidate here because validation works a little funny for these types of fields
      form.setFieldError(name, null);
    }
    form.setFieldValue(name, value);
    //we have to do this because even though they select one item, values is still an array
  };
  render() {
    const { fieldOptions, fieldNumber, values } = this.props;
    const { selectOptions } = this.state;
    return (
      <Field
        name={`references[${fieldNumber}].values`}
        render={({ field, form }) => {
          return (
            <OutlinedSelectInputChipped
              value={values}
              field={field}
              form={form}
              label={fieldOptions.label}
              options={selectOptions}
              multiple={true}
              onChange={event => {
                this._handleChange(form, event);
              }}
            />
          );
        }}
      />
    );
  }
}
